export default __webpack_public_path__ + "static/media/world-icn.6b26f8f0.svg";